<template>
  <div id="ImagesList">
    <div v-if="showMediaManager" class="media--manager">
      <div class="nav-mediaManager p-4">
        <i class="fas fa-chevron-down" @click="showMediaManager = false"></i>
      </div>
      <MediaManager 
        @receiveMedias="addPictures($event)" 
        @closeTabs="closeTabs()"
      />
    </div>
    <div class="row m-0 image-list">
      <div class="col-4 p-1 mb-2">
        <img
          class="img-fluid"
          @click="showMediaManager = true"
          src="../../assets/img/icons/add_picture@2x.png"
          alt
        />
      </div>
      <div
        class="col-4 p-1 mb-2"
        v-for="(image, index) in imageList"
        :key="index"
      >
        <BaseImage :fitIn="'200x200'" :source="image.content" />
        <span class="span-close-image-list">
          <i class="fas fa-times-circle" @click="removeImage(image)"></i>
        </span>
        
        <span v-if="image.type == 'script'" class="play-overlay">
          <i class="fas fa-play"></i>
        </span>
      </div>
      <div
        class="col-4 p-1 mb-2 d-flex justify-content-center align-items-center count--div"
        v-if="countList > 4 && showAll == false"
        @click="toggleExpand"
      >
        <span>+ {{ countList - imageList.length }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImagesList",
  data() {
    return {
      showMediaManager: false
    };
  },
  props: {
    imageList: {
      type: Array
    },
    countList: {
      type: Number
    },
    showAll: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  methods: {
    clearList,
    addItem,
    removeItem,
    addPictures,
    toggleExpand,
    removeImage,
    closeTabs() {
				this.showMediaManager = false;
		},	
  },
  components: {
    BaseImage: () => import("../atoms/BaseImage"),
    MediaManager: () => import("../organisms/MediaManager")
  }
};
function clearList() {}
function addItem() {}
function removeItem() {}
function addPictures(content) {
  let pictures = []
  content.forEach(element => {
    pictures.push(element.url)
  });
  this.$emit("addPictures", pictures);
  this.showMediaManager = false;
}
function toggleExpand() {
  this.$emit("changeExpand");
}
function removeImage(image) {
  this.$emit("removeImage", image);
}
</script>

<style>
.image-list {
  margin-bottom: 10px;
}
.image-list > div {
  position: relative;
  display: inline-block;
}
.image-list > div > img {
  width: 100%;
  height: 89px;
  object-fit: cover;
  border-radius: 6px;
}
.count--div {
  background-color: #fbfbfb;
  font-weight: 700;
  font-family: "Montserrat", sans-serif;
}
.span-close-image-list {
  position: absolute;
  right: 8px;
  top: 4px;
}
.play-overlay{
  position:absolute; 
  left:50%; 
  top:50%; 
  transform: translate(-50%, -50%);
  color: rgb(255, 255, 255, 0.75);
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/ImagesList.vue